// Library methods
import React from "react";
import { useTranslation } from "react-i18next";

// MUI Components
import Grid from "@mui/material/Grid";

// Components
import Alert from "../../../../components/UI/Alert";
import { useLiveUpdateStatusContext } from "../../../../contexts/LiveUpdateStatusContext";

const LiveUpdateAlerts = () => {
  // translations
  const { t } = useTranslation();

  const { device, isOnline, bothControllersDisconnected, hmdInProximity } =
    useLiveUpdateStatusContext();

  return (
    device &&
    (isOnline ? (
      <Grid display="flex" flexDirection="column" width="100%" gap="20px">
        {!hmdInProximity && (
          <Alert
            variant="error"
            alertContent={t("live_update_hmd_error")}
            aria-label="hmd-error-alert"
          />
        )}
        {bothControllersDisconnected && (
          <Alert
            variant="error"
            alertContent={t("live_update_no_controller_error")}
            aria-label="no-controllers-error-alert"
          />
        )}
      </Grid>
    ) : (
      <Alert
        variant="error"
        alertContent={t("live_update_offline")}
        aria-label="live-update-offline"
      />
    ))
  );
};

export default LiveUpdateAlerts;
